import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientBankIdentityRoute = createRoute({
	path: '/bank-identity',
	getParentRoute: () => clientRoute,
});
